import { enqueueSnackbar } from "notistack";

import CommonAlert from "@/components/CommonAlert";
import { useNewSaveDataGridChanges } from "@/requests/transport.mutations";
import { usePlanActions, usePlanShowPassengerToWelcomeTeamDialog } from "@/stores/use-plan-table";

function ShowPassengerToWelcomeTeamDialog() {
    const { isPending, mutateAsync } = useNewSaveDataGridChanges();

    const showPassengerToWelcomeTeamDialog = usePlanShowPassengerToWelcomeTeamDialog();
    const { updateShowPassengerToWelcomeTeamDialog } = usePlanActions();
    const handleConfirm = async () => {
        if (isPending || !showPassengerToWelcomeTeamDialog || !showPassengerToWelcomeTeamDialog.id) return;
        try {
            const [res] = await mutateAsync({
                changes: [
                    {
                        id: showPassengerToWelcomeTeamDialog.id,
                        showToWelcomeTeam: showPassengerToWelcomeTeamDialog.showToWelcomeTeam,
                    },
                ],
            });
            const message = res?.message || "";
            if (res?.ok) {
                handleClose();
                enqueueSnackbar(message, {
                    variant: "success",
                });
            } else {
                enqueueSnackbar(message, {
                    variant: "error",
                });
            }
        } catch (error) {
            console.error("User error:", error);
        }
        handleClose();
    };

    const handleClose = () => {
        updateShowPassengerToWelcomeTeamDialog(null);
    };

    return (
        <CommonAlert
            open={!!showPassengerToWelcomeTeamDialog}
            loading={isPending}
            description="confirmations.showPassengerToWelcomeTeam"
            color="primary"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                name: showPassengerToWelcomeTeamDialog?.name || "",
                count: showPassengerToWelcomeTeamDialog?.showToWelcomeTeam ? 1 : 2,
            }}
        ></CommonAlert>
    );
}

export default ShowPassengerToWelcomeTeamDialog;
